import useStore from "hooks/useStore";
import { FC, ReactElement } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";

interface Props {
    children: ReactElement
}

const ProtectedRoutes: FC<Props> = ({ children }) => {
    const { getToken, hasAccess, getDefaultPathByRole, getUser, getCurrentRole } = useStore();
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const token = getToken();
    
    // Special handling for mobile subscription route - allow if token is in URL
    const isMobileSubscriptionRoute = pathname === siteRoutes.hostMobileSubscription;
    const tokenInUrl = searchParams.get("token");

    // If this is the mobile subscription route and has a token in URL, allow it to render
    // The component will handle token verification
    if (isMobileSubscriptionRoute && tokenInUrl) {
        return children;
    }

    // If no token, redirect to login
    if (!token) {
        return <Navigate to={siteRoutes.login} />
    }

    // Check if user data exists - if token exists but no user data, redirect to login
    const userData = getUser();
    const currentRole = getCurrentRole();
    
    // If token exists but user data is missing or invalid, redirect to login
    if (!userData || !userData.user || !currentRole) {
        return <Navigate to={siteRoutes.login} />
    }

    // Check if user has access to the current route
    if (!hasAccess(pathname)) {
        const defaultPath = getDefaultPathByRole();
        // If defaultPath is null or invalid, redirect to login
        if (!defaultPath) {
            return <Navigate to={siteRoutes.login} />
        }
        return <Navigate to={defaultPath} />
    }

    return children;
}

export default ProtectedRoutes;